import { ReactElement } from 'react'
import { useStyles } from "./styles";

interface ButtonProps {
  text: string;
  type?: any;
  version?: string;
  icon?: ReactElement;
  isDisabled?: boolean;
  action?: Function;
  styles?: any;
}

function Button({
  text,
  version = 'primary',
  type,
  icon,
  isDisabled = false,
  action = () => {},
  styles
}: ButtonProps) {
  const classes = useStyles();
  let buttonClass = '';

  switch(version) {
    case 'secondary': 
      buttonClass = classes.buttonSecondary;
    break;
    case 'tertiary':
      buttonClass = classes.tertiary;
  }

  let iconClass = icon ? classes.hasIcon : '';
  let disabledClass = isDisabled ? classes.isDisabled : '';

  return (
    <button 
      type={type}
      className={`${classes.button} ${buttonClass} ${iconClass} ${disabledClass}`} 
      onClick={() => action()}
      disabled={isDisabled}
      style={{...styles}}
    >
      <div>{text}</div>
      {icon ? <span>{icon}</span> : null}
    </button>
  )
}

export default Button
